import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RuleSet } from 'angular2-query-builder';
import { apiUrl } from 'core/http/lg-logistic-rest-api/api/api.service';
import { StatusOutput } from 'core/http/project';
import { Observable } from 'rxjs';
import { Uuid } from 'shared/common/types';
import { Criteria } from 'shared/criteria/Criteria';

export interface ChainedStatusOutput {
  chainedId: string | null;
  ruleSet: RuleSet;
  status: StatusOutput;
  priority: number;
}

export interface StatusChainOutput {
  id: Uuid;
  name: string;
  chainedStatuses: ChainedStatusOutput[];
}

export interface StatusChainInput {
  name: string;
  chainedStatuses: ChainedStatusInput[];
}

export interface ChainedStatusInput {
  chainedId: string | null;
  statusId: string;
  priority: number;
  ruleSet: RuleSet;
}

@Injectable()
export class StatusChainService {
  constructor(private http: HttpClient) {}

  getAllStatusChains(criteria?: Criteria): Observable<StatusChainOutput[]> {
    return this.http.get<StatusChainOutput[]>(apiUrl('/project/status-chains', criteria));
  }

  createStatusChain(input: StatusChainInput): Observable<StatusChainOutput> {
    return this.http.post<StatusChainOutput>(apiUrl('/project/status-chain'), input);
  }

  updateStatusChain(chainId: Uuid, input: StatusChainInput): Observable<StatusChainOutput> {
    return this.http.put<StatusChainOutput>(apiUrl(`/project/status-chain/${chainId}`), input);
  }

  removeStatusChain(chainId: Uuid): Observable<object> {
    return this.http.delete(apiUrl(`/project/status-chain/${chainId}`));
  }
}
